import { useUnit } from 'effector-react'

import {
  $cardVerificationList,
  $totalCountOfCardVerification,
  $totalKPI,
  getCardVerification,
  cardVerificationMounted,
} from './model'
import { CardVerificationRequest } from './types'

export const useKPIList = () => {
  const kpiList = useUnit($cardVerificationList)
  const loading = useUnit(getCardVerification.pending)
  const totalCountOfKPI = useUnit($totalCountOfCardVerification)
  const totalKPI = useUnit($totalKPI)

  const onChangeKPIList = ({
    userIds,
    beginPeriodAt,
    endPeriodAt,
    page,
    limit,
  }: CardVerificationRequest) => {
    cardVerificationMounted({
      userIds,
      beginPeriodAt,
      endPeriodAt,
      page,
      limit,
    })
  }

  return { kpiList, loading, onChangeKPIList, totalCountOfKPI, totalKPI }
}
